import React from 'react';
import { Table, Card, Button, Space, Tag, Tooltip } from 'antd';
import { EyeOutlined, EditOutlined, HistoryOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { mockServices, mockRoutes, mockPlugins } from '../mockData';

type ServiceRecord = {
  key: string;
  name: string;
  status: string;
  routeCount: number;
  upstream: string;
  lastUpdated: string;
};

const ServiceOverview: React.FC = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: '服务名称',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: ServiceRecord) => (
        <a onClick={() => navigate(`/services/${record.key}`)}>{text}</a>
      ),
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? '运行中' : '已停止'}
        </Tag>
      ),
    },
    {
      title: '路由数',
      dataIndex: 'routeCount',
      key: 'routeCount',
    },
    {
      title: '上游服务',
      dataIndex: 'upstream',
      key: 'upstream',
    },
    {
      title: '最近更新',
      dataIndex: 'lastUpdated',
      key: 'lastUpdated',
    },
    {
      title: '操作',
      key: 'action',
      render: (_: unknown, record: ServiceRecord) => (
        <Space size="middle">
          <Tooltip title="查看详情">
            <Button type="link" icon={<EyeOutlined />} onClick={() => navigate(`/services/${record.key}`)} />
          </Tooltip>
          <Tooltip title="编辑配置">
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/services/${record.key}`)} />
          </Tooltip>
          <Tooltip title="变更历史">
            <Button type="link" icon={<HistoryOutlined />} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  // Transform mock data into the format we need
  const data: ServiceRecord[] = mockServices.map(service => {
    const serviceRoutes = mockRoutes.filter(route => route.service.id === service.id);
    const servicePlugins = mockPlugins.filter(plugin => plugin.service.id === service.id);
    
    return {
      key: service.id,
      name: service.name,
      status: 'active', // We could add this to the mock data structure
      routeCount: serviceRoutes.length,
      upstream: `${service.host}:${service.port}`,
      lastUpdated: service.updated_at,
    };
  });

  return (
    <div className="service-overview">
      <Card
        title="服务管理"
        extra={
          <Button type="primary" onClick={() => navigate('/service/new')}>新建服务</Button>
        }
      >
        <Table columns={columns} dataSource={data} />
      </Card>
    </div>
  );
};

export default ServiceOverview;